// mantine
import { Checkbox } from '@mantine/core';
// components
import { TChannel } from '@/types/common.ts';
import ChannelByIntegrationIdn from '@/components/ChannelByIntegrationIdn';
// utils

interface ChannelSelectProps {
    channels: TChannel[];
    onChange: (channels: TChannel[]) => void;
}

const ChannelByIntegrationIdnSelect = ({
    channels,
    onChange
}: ChannelSelectProps) => {
    const handleChange = (value: string[]) => {
        onChange(value as TChannel[]);
    };

    return (
        <Checkbox.Group
            label="Channels"
            size="xs"
            value={channels}
            onChange={handleChange}
        >
            <div className="flex flex-col gap-4 py-2">
                <Checkbox
                    label={
                        <ChannelByIntegrationIdn
                            channel="sms"
                            className="text-sm"
                        />
                    }
                    value="sms"
                />
                <Checkbox
                    label={
                        <ChannelByIntegrationIdn
                            channel="phone"
                            className="text-sm"
                        />
                    }
                    value="phone"
                />
                <Checkbox
                    label={
                        <ChannelByIntegrationIdn
                            channel="chat"
                            className="text-sm"
                        />
                    }
                    value="chat"
                />
            </div>
        </Checkbox.Group>
    );
};

export default ChannelByIntegrationIdnSelect;
